import React from 'react';

import { fetchPickupWindows } from '../dispensaries/dispensary-utils';
import { ZIP_RUN_GREEN } from '../../constants/colors';
import { getMaxDaysOut, getDefaultSlotForToday } from './timeslot-utils';
import DispensaryLogo from '../dispensary/DispensaryLogo';
import { CurrentTimeContext } from './CurrentTimeProvider';
import SelectDayCarousel from './SelectDayCarousel';
import SelectTimeSlotPreview from './SelectTimeSlotPreview';
import Spinner from '../common/Spinner';
import AccessTime from '@material-ui/icons/AccessTime';

import PropTypes from 'prop-types';

import styles from './SelectTimeSlot.module.css';

const DisplayPickupSlotsModal = ({
  dispensaryId,
  dispensaryName,
  logoImage
}) => {

  // Time to use when deterimining what to display
  const currentTimeMS = React.useContext(CurrentTimeContext);

  const daysOfWeek = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
  const dayOfWeek = new Date(currentTimeMS).getDay();
 
  // Valid timeSlots to display
  const [timeSlotsByDay, setTimeSlotsByDay] = React.useState([]);
  // The current day (tab) we're viewing
  const [displayDayIdx, setDisplayDayIdx] = React.useState(0);

  /**
   * Where most of the tricky business happens
   * 
   * TODO: Move to a util script this is used in 2 places
   */
  const timeSlotCallback = React.useCallback((response) => {
    // e.g. 2 for Tuesday
    const todayNum = new Date(currentTimeMS).getDay();     
    if (response.pickup_time_slots_for_week) {
      const slotsByDay = response.pickup_time_slots_for_week
      // e.g. starting Tuesday
      const weeklySlotsStartingToday = [ 
        slotsByDay[daysOfWeek[todayNum]],
        slotsByDay[daysOfWeek[(todayNum + 1) % 7]],
        slotsByDay[daysOfWeek[(todayNum + 2) % 7]],
        slotsByDay[daysOfWeek[(todayNum + 3) % 7]],
        slotsByDay[daysOfWeek[(todayNum + 4) % 7]],
        slotsByDay[daysOfWeek[(todayNum + 5) % 7]],
        slotsByDay[daysOfWeek[(todayNum + 6) % 7]]
      ];
      // Display only bookable days, but show at least one day
      const maxDaysOut = getMaxDaysOut(weeklySlotsStartingToday, currentTimeMS);
      const daysToShow = maxDaysOut > 0 ? maxDaysOut : 1;
      const validSlots =  weeklySlotsStartingToday.slice(0, daysToShow);
      setTimeSlotsByDay(validSlots);
     
      const defaultSlot = getDefaultSlotForToday(validSlots[0], currentTimeMS);  
      // TODO: We need some messaging if nothing is available
      if (defaultSlot === -1 && validSlots.length > 1) {
        setDisplayDayIdx(1);
      }  
    }
  }, [currentTimeMS, daysOfWeek]); 

  const controllerRef = React.useRef(new AbortController());

  // Fetch timeslots after determining time (with timezone offset)
  React.useEffect(() => {
    const controller = controllerRef.current;
    if (currentTimeMS && !timeSlotsByDay.length) {  
      fetchPickupWindows(dispensaryId, timeSlotCallback, controller);
    }
    // cancel fetch on unmount
    return () => controller.abort();
  }, [currentTimeMS, dispensaryId, timeSlotsByDay.length, timeSlotCallback]);

  return (
    <div className={styles.timeslotWrap}>
      { timeSlotsByDay.length
        ? <>
            <DispensaryLogo logoImage={logoImage} dispensaryName={dispensaryName} imgClass={styles.dispensaryLogo}/>
            <div className={styles.dispensaryName}>{dispensaryName}</div>
            <div className={styles.subHeader}>
              <AccessTime style={{verticalAlign:'-6px', color:ZIP_RUN_GREEN}}/>
              {' '}Preview pickup times
            </div> 

            <SelectDayCarousel
              displayDayIdx={displayDayIdx} 
              displayDayLabelIdx={dayOfWeek}
              timeSlotsByDay={timeSlotsByDay}
              currentTimeMS={currentTimeMS} 
              handleDayClick={setDisplayDayIdx} /> 

            <SelectTimeSlotPreview
              displayDayIdx={displayDayIdx}
              timeSlots={timeSlotsByDay[displayDayIdx]}
              currentTimeMS={currentTimeMS} />         
          </> 
        : <Spinner inSmallLayout />   
      }
    </div>
  )
}

DisplayPickupSlotsModal.propTypes = {
  dispensaryId: PropTypes.string.isRequired,
  dispensaryName: PropTypes.string.isRequired,
  logoImage: PropTypes.string.isRequired
};

export default DisplayPickupSlotsModal;